import React from "react";
import ChangePassword from "./ChangePassword";

export default (props) => (
  <div>
    <ChangePassword {...props} />
  </div>
);
